<h2>Rechte / Rollen</h2>
<h3>Beispiel-Rolle</h3>
<p-tabMenu [model]="items" [activeItem]="activeItem"></p-tabMenu>
<router-outlet name="tab"></router-outlet>
